export function normalizeAutomatedBillProvider(providerName) {
  const normalized = String(providerName || "")
    .trim()
    .toLowerCase();

  if (normalized === "mtc touch") return "touch";
  return normalized;
}

export function formatAutomatedBillStatus(status) {
  const normalized = String(status || "").trim().toLowerCase();
  if (["paused", "pause", "inactive", "disabled", "off"].includes(normalized)) {
    return "Paused";
  }

  return "Active";
}

export function isAutomatedBillActive(status) {
  return formatAutomatedBillStatus(status) === "Active";
}

export function isDisplayableAutomatedBillValue(value) {
  if (value === null || value === undefined) return false;

  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return false;

  return !["n/a", "na", "-", "--", "null", "undefined"].includes(normalized);
}

function getFirstDisplayableValue(...values) {
  return values.find((value) => isDisplayableAutomatedBillValue(value)) || "";
}

export function normalizeAutomatedBill(rawBill = {}, providerAssets = {}) {
  const providerName =
    getFirstDisplayableValue(
      rawBill?.providerName,
      rawBill?.ProviderName,
      rawBill?.Title,
      rawBill?.provider,
    ) ||
    "Bill Provider";
  const providerKey = normalizeAutomatedBillProvider(providerName);
  const providerAsset = providerAssets[providerKey] || {};
  const status = formatAutomatedBillStatus(rawBill?.status || rawBill?.Status);
  const amount = getFirstDisplayableValue(rawBill?.amount, rawBill?.Amount);

  return {
    id:
      rawBill?.id ||
      rawBill?.transactionId ||
      rawBill?.TransactionID ||
      `${providerKey}-${rawBill?.mobileNumber || rawBill?.MobileNumber || providerName}`,
    providerKey,
    providerName,
    providerImage: getFirstDisplayableValue(providerAsset?.image, rawBill?.Image),
    mobileNumber:
      getFirstDisplayableValue(
        rawBill?.mobileNumber,
        rawBill?.MobileNumber,
        rawBill?.phoneNumber,
        rawBill?.PhoneNumber,
      ),
    status,
    isChecked:
      typeof rawBill?.isChecked === "boolean"
        ? rawBill.isChecked
        : typeof rawBill?.IsChecked === "boolean"
          ? rawBill.IsChecked
          : isAutomatedBillActive(status),
    nextPaymentDate: getFirstDisplayableValue(
      rawBill?.nextPaymentDate,
      rawBill?.NextPaymentDate,
      rawBill?.nextPayment,
      rawBill?.NextPayment,
    ),
    frequency: getFirstDisplayableValue(
      rawBill?.frequencly,
      rawBill?.Frequency,
      rawBill?.frequency,
    ),
    amount,
    original: rawBill,
  };
}

export function buildProviderAssets(providers = []) {
  return (Array.isArray(providers) ? providers : []).reduce((accumulator, provider) => {
    const providerKey = normalizeAutomatedBillProvider(provider?.Title || provider?.providerName);
    if (!providerKey) return accumulator;

    accumulator[providerKey] = {
      image: provider?.Image || "",
      title: provider?.Title || provider?.providerName || "",
    };
    return accumulator;
  }, {});
}

export function getAutomatedToggleResponseValue(response, fallbackValue) {
  if (typeof response?.isChecked === "boolean") return response.isChecked;
  if (typeof response?.IsChecked === "boolean") return response.IsChecked;
  if (typeof response?.data?.isChecked === "boolean") return response.data.isChecked;
  if (typeof response?.data?.IsChecked === "boolean") return response.data.IsChecked;
  if (typeof response?.Payload?.isChecked === "boolean") return response.Payload.isChecked;
  if (typeof response?.Payload?.IsChecked === "boolean") return response.Payload.IsChecked;

  return fallbackValue;
}
